import { below } from 'common/utils/breakpoint';
import { system200, system800, error } from 'common/components/Mui/styles/color';

export const generateMuiTextFieldCustomColorStyle = styles => ({
    '.MuiInputBase-root': styles,
    '.MuiInput-underline:before, .MuiInput-underline:after, .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottomColor: styles.color
    },
    '.MuiInput-underline.Mui-error:before, .MuiInput-underline.Mui-error:after': {
        borderBottomColor: error.color
    },
    '.MuiIconButton-root': {
        color: styles.color
    },
    '.MuiInputBase-input.MuiInput-input': {
        textAlign: 'inherit',
        minHeight: 24
    }
});

export const generateMuiSelectCustomColorStyle = styles => ({
    '&.MuiInputBase-root': styles,
    '& .MuiInput-underline:not(.Mui-error):before, & .MuiInput-underline:not(.Mui-error):after, & .MuiInput-underline:not(.Mui-error):hover:not(.Mui-disabled):before': {
        borderBottomColor: styles.color
    },
    '& .MuiInput-underline.Mui-error:before, & .MuiInput-underline.Mui-error:after': {
        borderBottomColor: error.color
    },
    '& .MuiSelect-root.Mui-disabled': {
        opacity: 0.5
    },
    '& .MuiSvgIcon-root.MuiSelect-icon': {
        color: styles.color
    }
});

export const muiTextFieldSpaceStyle = `
    line-height: 1.1875;
    padding: 7px 0;
    letter-spacing: 0.5px;
`;

export const fieldWrapperStyle = `
    padding: 32px 48px 16px;
    ${below('sm')} {
        padding: 32px 16px 16px;
    }
`;

export const fieldTitleStyle = `
    margin-bottom: 0.25rem;
    color: #333333;
    font-size: 1.125rem;
    line-height: 25px;
    overflow-wrap: break-word;
    white-space: pre-wrap;
`;

export const fieldDescStyle = `
    margin-bottom: 0.5rem;
    font-size: 1rem;
    color: #818181;
    line-height: 24px;
    overflow-wrap: break-word;
    white-space: pre-wrap;
`;

export const fieldInputTextStyle = `
    background: #ECECEC;
    border: 1px solid #475669;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 8px;
    width: 100%;
`;

export const fieldInputTextAreaStyle = `
    line-height: 24px;
    background: #ECECEC;
    border: 1px solid #475669;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 8px;
    width: 100%;
    height: 108px;

    ${below('sm')} {
        height: 160px;
    }
`;

export const isEditModeStyle = `
    border: dashed 1px #CCCCCC;
    line-height: 24px;
    letter-spacing: 0.1em;
    padding: 0;
    width: 100%;
    resize: none;
    outline: none;
    box-sizing: border-box;
    background: initial;
`;

export const optionsBlockWidthStyle = items => `
    width: ${items === 1 ? 80 : 100}%;
    ${below('sm')} {
        width: 100%;
    }
`;

export const imgOptionsBlockWidthStyle = items => `
    width: ${items === 1 ? 50 : 100}%;
    ${below('sm')} {
        width: 100%;
    }
`;

export const optionWrapperStyle = `
    position: relative;
    background: #ECECEC;
    border: 2px solid #ECECEC;
    box-sizing: border-box;
    padding: 8px;
    border-radius: 4px;
    width: 100%;
    height: 100%;
`;

export const optionPromoWrapperStyle = `
    position: relative;
    background: ${system200.color};
    box-sizing: border-box;
    padding: 0;
    border-radius: 4px;
    width: 100%;
    height: 100%;
`;

export const optionTextStyle = `
    font-family: Noto Sans TC;
    font-weight: 500;
    font-size: 16px;
    line-height: 140%;
    letter-spacing: 0.15px;
    margin: 4px 0;
    min-height: 24px;
    overflow-wrap: break-word;
    overflow-y: hidden;
    display: flex;
    align-items: center;
`;

export const optionPromoTextStyle = `
    margin: 5.5px 0;
    overflow-wrap: break-word;
    overflow-y: hidden;
    height: 100%;
`;

export const optionDeleteButtonStyle = `
    color: #9B9B9B;
    position: absolute;
    top: -5px;
    right: -5px;
    height: 16px;
    width: 16px;
    font-size: 16px !important;
    line-height: 1 !important;
    cursor: pointer;
`;

export const deleteIconStyle = `
    position: absolute;
    top: -12px;
    right: -12px;
    cursor: pointer;
    font-size: 24px;
    background: #fff;
    color: ${system800.color};
    border-radius: 50%;
    z-index: 1;
`;

export const textAlignMapping = {
    0: 'left',
    1: 'center',
    2: 'right'
};

export const optionTextAlignStyle = type => {
    return `text-align: ${textAlignMapping[type]}`;
};

export const optionImageWrapperStyle = `
    margin-bottom: 8px;
    img {
        display: block;
        width: 100%;
        max-width: 100%;
    }
`;

export const optionImageCoverWrapperStyle = imgUrl => `
    background-image: url(${imgUrl});
    width: 100%;
    padding-bottom: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
`;

export const imageCoverWrapperStyle = imgUrl => `
    background-image: url(${imgUrl});
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
`;

export const dropSelectItemStyle = `
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 8px;
    overflow-wrap: break-word;
    &:hover {
        background: rgba(71,86,105,0.25);
    }
`;

export const selectWrapperStyle = (length, mode = '') => `
    height:${length * (mode === 'client' ? 30 : 38)}px;
    max-height: 226px;
`;

export const selectPlaceHolderStyle = `
    margin-bottom: 0.5rem;
    color: #CCCCCC;
    position: relative;
    min-height: 36px;
    word-break: keep-all;
    padding-right: 24px;
    text-overflow: ellipsis;
`;

export const iconWrapperStyle = `
    position: absolute;
    top: 0px;
    right: 0px;
    height: 100%;
    width: 34px;
    border-radius: 3px;
`;

export const triangleStyle = `
    width: 0px;
    height: 0px;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-top: 9px solid #475669;
    border-radius: 5px;
`;

export const dropIconStyle = `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const iconEffect = isActive => `
    transition: 0.3s;
    ${isActive && 'transform: rotate(180deg) translate(50%, 50%);'}
`;

export const dropDownBlockStyle = `
    background: #ECECEC;
    border: 1px solid #475669;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 8px 0;
`;

export const focusSelectStyle = `
    background: rgba(71, 86, 105, 0.25);
`;

export const imageExistStyle = `
    > .upload-icon {
        display: none;
    }
    :hover > .upload-icon {
        display: block;
    }
`;

export const changeLineStyle = `
    overflow-wrap: break-word;
    white-space: pre-wrap;
`;
